class YouAlsoLikeRebuy extends HTMLElement {
  static isGlobalLoading = false;
  static isGlobalLoaded = false;

  constructor() {
    super();
  }

  connectedCallback() {

    if (YouAlsoLikeRebuy.isGlobalLoading || YouAlsoLikeRebuy.isGlobalLoaded) return;

    if (window.Rebuy) {
      this.startProcess();
    } else {
      document.addEventListener('rebuy:ready', () => this.startProcess(), { once: true });
    }
  }

  async startProcess() {
    if (YouAlsoLikeRebuy.isGlobalLoading || YouAlsoLikeRebuy.isGlobalLoaded) return;
    YouAlsoLikeRebuy.isGlobalLoading = true;

    this.initRebuy();
  }

  initRebuy() {
    const apiKey = this.getAttribute('rebuy-api-key');
    const sourceId = this.getAttribute('rebuy-source-id');
    const shopifyProductIds = this.getAttribute('shopify_product_ids');
    const limit = parseInt(this.getAttribute('limit') || '4', 10);

    if (!sourceId || !apiKey) {
      YouAlsoLikeRebuy.isGlobalLoading = false;
      return;
    }

    const apiUrl = `https://rebuyengine.com/api/v1/custom/id/${sourceId}?key=${apiKey}&shopify_product_ids=${shopifyProductIds}`;

    fetch(apiUrl)
      .then((res) => {
        if (!res.ok) throw new Error(`Error en Rebuy API: ${res.statusText}`);
        return res.json();
      })
      .then((response) => {
        const recommendedProducts = response.data?.recommendations || response.recommendations || response.data;

        if (recommendedProducts && recommendedProducts.length > 0) {
          this.fetchProductCards(recommendedProducts.slice(0, limit));
        } else {
          YouAlsoLikeRebuy.isGlobalLoading = false;
        }
      })
      .catch((error) => {
        console.error('Rebuy API Error:', error);
        YouAlsoLikeRebuy.isGlobalLoading = false;
      });
  }

  fetchProductCards(products) {
    const sectionId = 'product-card-loader';

    const fetchPromises = products.map(product => {
      return fetch(`/products/${product.handle}?sections=${sectionId}`)
        .then(res => {
          if (!res.ok) throw new Error(`Error al renderizar la tarjeta de ${product.handle}`);
          return res.json();
        })
        .then(json => {
          return json[sectionId] || '';
        });
    });

    Promise.all(fetchPromises)
      .then((htmlResults) => {
        const combinedHtml = htmlResults.filter(html => html.trim() !== '').join('');
        
        YouAlsoLikeRebuy.isGlobalLoaded = true;
        YouAlsoLikeRebuy.isGlobalLoading = false;

        this.renderCards(combinedHtml);
      })
      .catch(err => {
        console.error('Error processing product cards with Section API:', err);
        YouAlsoLikeRebuy.isGlobalLoading = false;
      });
  }

  renderCards(htmlContent) {
    const container = this.querySelector('[data-you-may-also-like-container]');
    const sectionStack = this.querySelector('[data-section-stack]');

    if (!container || !sectionStack || !htmlContent) return;

    const sectionId = this.getAttribute('section-id') || 'rebuy-recommendations';
    const hideProductInfo = this.getAttribute('hide-product-information') === 'true';
    const carouselId = `carousel-${sectionId}`;
    const compactClass = hideProductInfo ? 'product-list--compact' : '';

    const productListHTML = `
      <product-list class="floating-controls-container floating-controls-container--inside floating-controls-container--on-hover" data-products-target>
        <scroll-carousel id="${carouselId}" group-cells allow-drag class="product-list ${compactClass} product-list--carousel scroll-area bleed md:unbleed" data-carousel-target>
          ${htmlContent}
        </scroll-carousel>

        <button is="carousel-prev-button" type="button" class="prev-next-button prev-next-button--prev circle-button hover:animate-icon-inline" aria-controls="${carouselId}" disabled>
          <span class="sr-only">Anterior</span>
          <svg role="presentation" class="icon icon-arrow-left " viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 15L5 10L10 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <button is="carousel-next-button" type="button" class="prev-next-button prev-next-button--next circle-button hover:animate-icon-inline" aria-controls="${carouselId}">
          <span class="sr-only">Siguiente</span>
          <svg role="presentation" class="icon icon-arrow-right " viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 5L11 10L6 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </product-list>
    `;

    const existingList = sectionStack.querySelector('product-list');
    if (existingList) existingList.remove();

    sectionStack.insertAdjacentHTML('beforeend', productListHTML);

    container.style.display = '';

    const carousel = this.querySelector('[data-carousel-target]');
    const productList = this.querySelector('[data-products-target]');

    if (carousel) {
      const productCards = carousel.querySelectorAll('product-card.product-card');
      
      productCards.forEach(card => {
        card.dispatchEvent(new CustomEvent('product-card:loaded', { bubbles: true }));

        if (card.hasAttribute('reveal-on-scroll')) {
          card.removeAttribute('reveal-on-scroll');
        }
      });

      if (typeof carousel.onContentChange === 'function') {
        carousel.onContentChange();
      } else {
        carousel.dispatchEvent(new CustomEvent('theme:carousel:reinit', { bubbles: true }));
        window.dispatchEvent(new Event('resize'));
      }
    }

    if (productList && typeof productList.init === 'function') {
      productList.init();
    }
  }
}

if (!customElements.get('you-also-like-rebuy')) {
  customElements.define('you-also-like-rebuy', YouAlsoLikeRebuy);
}